import { Zap, ClipboardCheck, Hammer, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import sideImg from "@/assets/oz-mascot-property.webp";

const features = [
  {
    icon: Zap,
    heading: "Fast photo-based quotes",
    description:
      "Send photos and details so we can quote quickly without unnecessary back and forth.",
  },
  {
    icon: ClipboardCheck,
    heading: "Clear scope before we start",
    description:
      "We explain what is included, what is excluded and what may affect the final price.",
  },
  {
    icon: Hammer,
    heading: "Practical, reliable workmanship",
    description:
      "We focus on clean finishes, strong installation and work that suits the property.",
  },
  {
    icon: MessageCircle,
    heading: "Easy communication",
    description:
      "We keep you updated before, during and after the job.",
  },
];

const MovingSimpleSection = () => (
  <section className="bg-[#f7f7f7] py-16 md:py-24">
    <div className="container">
      <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
        {/* Left side */}
        <div className="w-full lg:w-1/2">
          <h2 className="text-3xl md:text-4xl font-black text-[#1a1a1a] leading-tight mb-10">
            Property Work Made Simple
          </h2>

          <div className="space-y-8">
            {features.map((f) => (
              <div key={f.heading} className="flex gap-4">
                <div className="shrink-0 w-10 h-10 rounded-lg bg-[#FFC300]/15 flex items-center justify-center mt-0.5">
                  <f.icon className="w-5 h-5 text-[#1a1a1a]" strokeWidth={2} />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-[#1a1a1a] mb-1">
                    {f.heading}
                  </h3>
                  <p className="text-[#1a1a1a]/75 text-sm leading-relaxed">
                    {f.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <Link
            to="/get-quote"
            className="inline-block mt-10 bg-[#1a1a1a] text-[#FFC300] px-8 py-4 text-lg font-bold rounded-md hover:opacity-90 transition-opacity"
          >
            Get Free Quote
          </Link>
        </div>

        {/* Right side - illustration */}
        <div className="w-full lg:w-1/2 flex items-center justify-center">
          <div className="bg-[#FFC300] rounded-3xl p-4 w-full max-w-md">
            <img
              src={sideImg}
              alt="Oz Property Services Co. kangaroo mascot with feature wall, fencing and tools"
              className="w-full h-auto rounded-2xl object-contain"
              loading="lazy"
              width={1512}
              height={1024}
            />
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default MovingSimpleSection;
